var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7812 6.22231V4.01562C19.7812 2.07711 18.2041 0.5 16.2656 0.5H2.85938C1.31742 0.5 0 1.74612 0 3.3125V4.71875H4.26562V20.2344C4.26562 22.5744 6.16073 24.5 8.48438 24.5H22.5938V23.0938C21.0429 23.0938 19.7812 21.811 19.7812 20.2344V19.2627L22.5938 20.669V14.5346C23.4631 13.6465 24 12.4318 24 11.0938C24 8.61852 22.1632 6.56455 19.7812 6.22231ZM1.40625 3.3125C1.40625 2.55022 2.07169 1.90625 2.85938 1.90625C3.63478 1.90625 4.26562 2.53709 4.26562 3.3125H1.40625ZM8.48438 23.0938C6.93356 23.0938 5.67188 21.811 5.67188 20.2344C5.67188 19.7268 5.67188 3.932 5.67188 3.3125C5.67188 2.80039 5.53364 2.3203 5.2935 1.90625H16.2656C17.4287 1.90625 18.375 2.85252 18.375 4.01562V6.22231C15.993 6.56455 14.1562 8.61852 14.1562 11.0938C14.1562 12.4318 14.6932 13.6465 15.5625 14.5346V20.669L18.375 19.2627V20.2344C18.375 21.2966 18.7632 22.3045 19.4722 23.0938H8.48438ZM21.1875 18.3935L19.0781 17.3389L16.9688 18.3935V15.5401C17.6085 15.8448 18.3237 16.0156 19.0781 16.0156C19.8326 16.0156 20.5478 15.8448 21.1875 15.5401V18.3935ZM19.0781 14.6094C17.1396 14.6094 15.5625 13.0323 15.5625 11.0938C15.5625 9.15523 17.1396 7.57812 19.0781 7.57812C21.0166 7.57812 22.5938 9.15523 22.5938 11.0938C22.5938 13.0323 21.0166 14.6094 19.0781 14.6094Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07812 4.76562H15.5625V6.17188H7.07812V4.76562Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07812 8.98438H12.75V10.3906H7.07812V8.98438Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07812 13.2031H12.75V14.6094H7.07812V13.2031Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07812 17.4219H12.75V18.8281H7.07812V17.4219Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 8.98438C17.915 8.98438 16.9688 9.93064 16.9688 11.0938C16.9688 12.2569 17.915 13.2031 19.0781 13.2031C20.2412 13.2031 21.1875 12.2569 21.1875 11.0938C21.1875 9.93064 20.2412 8.98438 19.0781 8.98438ZM19.0781 11.7969C18.6904 11.7969 18.375 11.4815 18.375 11.0938C18.375 10.706 18.6904 10.3906 19.0781 10.3906C19.4658 10.3906 19.7812 10.706 19.7812 11.0938C19.7812 11.4815 19.4658 11.7969 19.0781 11.7969Z",
    fill: "#737373"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/Certification.b767d049d18b6fac86b05e8e592fcf21.svg";
export { ForwardRef as ReactComponent };